<nav class="ticket-breadcrumb">
  @if (etat.parcSelectionne()) {
    <a class="ticket-breadcrumb-item" [routerLink]="['/parc']"
      >Parc {{ etat.parcSelectionne()!.libelle }}</a
    >
    <span class="ticket-breadcrumb-sep">›</span>
  }
  @if (installation(); as installationChargee) {
    <a class="ticket-breadcrumb-item" [routerLink]="['/installation', installationChargee.id]">{{
      installationChargee.nom
    }}</a>
    <span class="ticket-breadcrumb-sep">›</span>
  }
  @if (ticket()) {
    <span class="ticket-breadcrumb-current">{{ ticket()!.reference }}</span>
  }
</nav>

@if (erreurChargement()) {
  <p role="alert">{{ erreurChargement() }}</p>
}

<div class="ticket-detail-grid">
  <div class="ticket-detail-main">
    <app-spinner-overlay [visible]="changementStatutEnCours()" label="Mise à jour du statut..." />

    @if (ticket()) {
      <div class="panel ticket-detail-card">
        <div class="ticket-detail-card-header">
          <div class="ticket-detail-card-main">
            <div class="ticket-detail-badges">
              <span
                class="ticket-detail-ref"
                [class]="
                  ticket()!.referenceClass
                    ? 'ticket-detail-ref ' + ticket()!.referenceClass
                    : 'ticket-detail-ref'
                "
                >{{ ticket()!.reference }}</span
              >

              @if (siloState()) {
                <span class="ticket-detail-status" [class]="ticketStatusClass(siloState()!)">
                  {{ ticketStatusLabel(siloState()!) }}
                </span>
              }

              @if (ticket()!.priority) {
                <span class="ticket-detail-priority">
                  <span class="material-symbols-outlined">flag</span>
                  {{ ticket()!.priority }}
                </span>
              }
            </div>

            <p class="ticket-detail-issue" [innerHTML]="ticket()!.issue"></p>

            @if (premierMessage(); as message) {
              <p class="ticket-detail-description">{{ message.commentaire }}</p>
            } @else if (ticket()!.description) {
              <p class="ticket-detail-description">{{ ticket()!.description }}</p>
            }
          </div>

          <div class="ticket-detail-actions">
            @if (installation()) {
              <button
                type="button"
                class="ticket-detail-btn ticket-detail-btn-ghost"
                [disabled]="chargement() || !installation()"
                (click)="annuaireOuvert.set(true)"
                aria-label="Afficher l'annuaire de l'installation"
              >
                <span class="material-symbols-outlined">contact_phone</span>
                Annuaire
              </button>
            }
            <div class="ticket-detail-status-actions" #menuStatutContainer>
              <button
                type="button"
                class="ticket-detail-btn ticket-detail-btn-ghost"
                [disabled]="
                  transitionsStatutDisponibles().length === 0 || changementStatutEnCours()
                "
                (click)="toggleMenuStatut()"
              >
                <span class="material-symbols-outlined">swap_horiz</span>
                Changer de statut
              </button>

              @if (menuStatutOuvert()) {
                <div class="ticket-detail-status-menu">
                  @for (targetState of transitionsStatutDisponibles(); track targetState) {
                    <button
                      type="button"
                      class="ticket-detail-status-option"
                      [disabled]="changementStatutEnCours()"
                      (click)="changerStatut(targetState)"
                    >
                      {{ libelleEtatTransition(targetState) }}
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        @if (erreurStatut()) {
          <p class="ticket-detail-status-error">{{ erreurStatut() }}</p>
        }

        <div class="ticket-detail-meta">
          <div class="ticket-detail-meta-item">
            <span class="material-symbols-outlined">calendar_month</span>
            <span class="ticket-detail-meta-label">Date d'ouverture du ticket</span>
            <span class="ticket-detail-meta-value">{{ ticket()!.dateDebut }}</span>
          </div>

          @if (ticket()!.dateFin) {
            <div class="ticket-detail-meta-item">
              <span class="material-symbols-outlined">event_available</span>
              <span class="ticket-detail-meta-label">Date de fermeture</span>
              <span class="ticket-detail-meta-value">{{ ticket()!.dateFin }}</span>
            </div>
          }

          @if (ticket()!.nbMessages !== undefined) {
            <div class="ticket-detail-meta-item">
              <span class="material-symbols-outlined">forum</span>
              <span class="ticket-detail-meta-label">Nombre de messages</span>
              <span class="ticket-detail-meta-value">{{ ticket()!.nbMessages }}</span>
            </div>
          }
        </div>
      </div>

      <div class="panel ticket-detail-historique">
        <div class="ticket-detail-historique-header">
          <h2>Interventions</h2>
          <app-intervention-acces
            [ticketId]="ticketId"
            [installationId]="installation()?.id ?? null"
            texteBouton="Ajouter"
            libelle="Ajouter une intervention"
          />
        </div>
        @if (chargementHistorique()) {
          <p class="ticket-detail-empty" role="status">Chargement des interventions…</p>
        } @else if (erreurHistorique()) {
          <p role="alert">{{ erreurHistorique() }}</p>
          <button type="button" class="activite-bon-consulter" (click)="chargerHistorique()">
            Réessayer
          </button>
        }
        @if (interventionsDuTicket().length || (!chargementHistorique() && !erreurHistorique())) {
          @for (section of sectionsInterventions(); track section.titre) {
            <section class="interventions-section" [attr.aria-label]="section.titre">
              <h3>
                {{ section.titre }} <span>{{ section.interventions.length }}</span>
              </h3>
              @if (!section.interventions.length) {
                <p class="interventions-section-vide">{{ section.vide }}</p>
              }
              <ul class="historique-interventions">
                @for (
                  intervention of section.interventions;
                  track intervention.type + '-' + intervention.id
                ) {
                  <li>
                    <button
                      type="button"
                      class="historique-intervention-ligne"
                      [attr.aria-label]="
                        'Consulter l’intervention du ' +
                        formaterDateHeure(intervention.date_deb || intervention.date_intervention)
                      "
                      (click)="ouvrirInterventionHistorique(intervention, $event)"
                    >
                      <span class="historique-intervention-date">
                        <time
                          [attr.datetime]="intervention.date_deb || intervention.date_intervention"
                          >{{
                            dateHistorique(intervention.date_deb || intervention.date_intervention)
                          }}</time
                        >
                        <span>
                          ·
                          {{
                            horairesHistorique(
                              intervention.nature === 'planification'
                                ? intervention.date_deb
                                : intervention.date_deb || intervention.date_intervention,
                              intervention.date_fin
                            )
                          }}</span
                        >
                      </span>
                      <span class="historique-intervention-contenu">
                        <strong>{{
                          intervention.commentaire ||
                            'Intervention ' +
                              libelleTypeIntervention(intervention.type).toLocaleLowerCase('fr')
                        }}</strong>
                        <span>{{ intervention.intervenant || 'Intervenant non renseigné' }}</span>
                      </span>
                      <span
                        class="historique-intervention-statut"
                        [class.est-cloturee]="
                          intervention.nature !== 'planification' && intervention.pb_resolu === true
                        "
                      >
                        {{
                          intervention.nature === 'planification'
                            ? 'Planifiée'
                            : intervention.pb_resolu === true
                              ? 'Clôturée'
                              : intervention.pb_resolu === false
                                ? 'Non clôturée'
                                : 'Non renseigné'
                        }}
                      </span>
                    </button>
                  </li>
                }
              </ul>
            </section>
          }
        }
      </div>
    } @else {
      <div class="panel ticket-detail-not-found">
        <span class="material-symbols-outlined">error_outline</span>
        <p>Ticket introuvable. Veuillez revenir à la liste.</p>
        <a class="ticket-detail-back" [routerLink]="retourUrl">Retour aux tickets</a>
      </div>
    }
  </div>

  <div class="panel ticket-detail-activity">
    <div class="ticket-detail-activity-header">
      <h2>Fil d'activité</h2>
      <div
        class="ticket-detail-activity-toolbar"
        role="group"
        aria-label="Actions et filtres du fil d’activité"
      >
        <button
          type="button"
          class="ticket-detail-filter-toggle"
          [class.ticket-detail-filter-toggle-active]="!masquerEvenements()"
          [attr.aria-pressed]="!masquerEvenements()"
          [disabled]="nombreEvenements() === 0"
          (click)="toggleMasquerEvenements()"
        >
          Événements ({{ nombreEvenements() }})
        </button>
        <button
          type="button"
          class="ticket-detail-filter-toggle"
          [class.ticket-detail-filter-toggle-active]="!masquerBonsIntervention()"
          [attr.aria-pressed]="!masquerBonsIntervention()"
          [attr.aria-label]="'Bons d’intervention (' + nombreBonsIntervention() + ')'"
          title="Bons d’intervention"
          [disabled]="nombreBonsIntervention() === 0"
          (click)="toggleMasquerBonsIntervention()"
        >
          Bons d’intervention ({{ nombreBonsIntervention() }})
        </button>
      </div>
    </div>

    <div class="ticket-detail-activity-feed" #activiteFeed>
      @if (chargementFeed()) {
        <p class="ticket-detail-empty">Chargement...</p>
      } @else if (feed().length === 0) {
        <p class="ticket-detail-empty">Aucune activité.</p>
      } @else {
        @for (entree of feed(); track $index; let i = $index) {
          @if (afficherSeparateur(i)) {
            <div class="activite-separateur">
              {{ formaterSeparateur(entree.date.toISOString()) }}
            </div>
          }

          @if (entree.type === 'intervention') {
            @if (estInterventionSysteme(entree.intervention)) {
              <article class="activite-bon">
                <div class="activite-bon-entete">
                  <span class="material-symbols-outlined activite-bon-icone" aria-hidden="true"
                    >assignment_turned_in</span
                  >
                  <div class="activite-bon-identite">
                    <h3>Bon d’intervention</h3>
                    @if (entree.intervention.intervenant) {
                      <p>{{ entree.intervention.intervenant }}</p>
                    }
                  </div>
                  <span
                    class="activite-bon-statut"
                    [class.est-resolu]="entree.intervention.pb_resolu"
                  >
                    {{ entree.intervention.pb_resolu ? 'Problème résolu' : 'Non résolu' }}
                  </span>
                </div>
                <div class="activite-bon-actions">
                  <button
                    type="button"
                    class="activite-bon-consulter"
                    (click)="ouvrirInterventionModal(entree.intervention, $event)"
                  >
                    <span class="material-symbols-outlined" aria-hidden="true">visibility</span>
                    Consulter le bon
                  </button>
                  <app-intervention-acces
                    [ticketId]="ticketId"
                    [installationId]="installation()?.id ?? null"
                    [edition]="editionBon(entree.intervention)"
                  />
                  <app-intervention-suppression [edition]="editionBon(entree.intervention)" />
                </div>
              </article>
            } @else {
              <div
                class="activite-message"
                [class.activite-message-own]="estMessageUtilisateurCourant(entree.intervention)"
              >
                @if (!estMessageUtilisateurCourant(entree.intervention)) {
                  <div class="activite-avatar">
                    {{ initialesIntervenant(entree.intervention.intervenant) }}
                  </div>
                }
                <div
                  class="activite-bulle"
                  [class.activite-bulle-own]="estMessageUtilisateurCourant(entree.intervention)"
                >
                  <div class="activite-meta">
                    <span class="activite-intervenant">{{ entree.intervention.intervenant }}</span>
                  </div>
                  <p class="activite-commentaire">{{ entree.intervention.commentaire }}</p>
                </div>
              </div>
            }
          } @else {
            @if (estEvenementFermeture(entree.evenement)) {
              <div class="activite-evenement activite-evenement-fermeture">
                @if (doitAfficherDateEntree(i)) {
                  <span class="activite-evenement-date">{{
                    formaterDateHeure(entree.evenement.date)
                  }}</span>
                }
                <span class="activite-evenement-texte">{{
                  formaterPhraseEvenementFeed(entree.evenement)
                }}</span>
              </div>
            } @else if (estEvenementChangementStatut(entree.evenement)) {
              <div class="activite-evenement activite-evenement-statut">
                @if (doitAfficherDateEntree(i)) {
                  <span class="activite-evenement-date">{{
                    formaterDateHeure(entree.evenement.date)
                  }}</span>
                }
                <span class="activite-evenement-texte">{{
                  formaterPhraseEvenementFeed(entree.evenement)
                }}</span>
              </div>
            } @else if (estEvenementLibelleMetier(entree.evenement)) {
              <div class="activite-evenement">
                @if (doitAfficherDateEntree(i)) {
                  <span class="activite-evenement-date">{{
                    formaterDateHeure(entree.evenement.date)
                  }}</span>
                }
                <span class="activite-evenement-texte">{{
                  formaterPhraseEvenementFeed(entree.evenement)
                }}</span>
              </div>
            } @else {
              <div class="activite-evenement">
                @if (doitAfficherDateEntree(i)) {
                  <span class="activite-evenement-date">{{
                    formaterDateHeure(entree.evenement.date)
                  }}</span>
                }
                <span class="activite-evenement-champ">{{
                  formaterChampEvenement(entree.evenement.champ)
                }}</span>
                <span class="activite-evenement-avant">{{
                  formaterValeurEvenement(
                    entree.evenement.champ,
                    entree.evenement.valeur_avant ?? ''
                  )
                }}</span>
                <span class="activite-evenement-fleche">→</span>
                <span class="activite-evenement-apres">{{
                  formaterValeurEvenement(
                    entree.evenement.champ,
                    entree.evenement.valeur_apres ?? ''
                  )
                }}</span>
                @if (entree.evenement.personne) {
                  <span class="activite-evenement-personne"
                    >- {{ formaterAuteurEvenement(entree.evenement.personne) }}</span
                  >
                }
              </div>
            }
          }
        }
      }
    </div>

    <div class="ticket-detail-activity-input">
      <div class="ticket-detail-composer" [class.ticket-detail-composer-sending]="envoiMessage()">
        <div class="ticket-detail-composer-main">
          <span class="material-symbols-outlined ticket-detail-composer-icon">chat</span>
          <textarea
            #messageTextarea
            class="ticket-detail-activity-textarea"
            rows="1"
            maxlength="5000"
            placeholder="Écrire un message..."
            [ngModel]="message()"
            (ngModelChange)="message.set($event); onMessageInput()"
            (keydown)="onMessageKeydown($event)"
            [disabled]="envoiMessage()"
          ></textarea>
        </div>
        <button
          type="button"
          class="ticket-detail-send-btn"
          [disabled]="envoiMessage() || !message().trim()"
          (click)="envoyerMessage()"
        >
          <span class="material-symbols-outlined">send</span>
          {{ envoiMessage() ? 'Envoi...' : 'Envoyer' }}
        </button>
      </div>
      <div class="ticket-detail-activity-input-actions">
        @if (erreurMessage()) {
          <p class="ticket-detail-activity-error">{{ erreurMessage() }}</p>
        }
        <p class="ticket-detail-activity-hint">
          Entrée pour un saut de ligne, Ctrl+Entrée pour envoyer.
        </p>
      </div>
    </div>
  </div>
</div>

@if (interventionModalData(); as modal) {
  <app-intervention-modal [data]="modal" (fermer)="fermerInterventionModal()" />
}

@if (annuaireOuvert()) {
  <div class="ticket-detail-modal-backdrop" (click)="fermerAnnuaireSurBackdrop($event)">
    <div
      class="ticket-detail-modal ticket-detail-contacts-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="annuaire-title"
    >
      <div class="ticket-detail-modal-header">
        <div>
          <p class="ticket-detail-modal-eyebrow">Installation</p>
          <h2 id="annuaire-title">Annuaire — {{ installation()?.nom }}</h2>
        </div>
        <button
          type="button"
          class="ticket-detail-modal-close"
          (click)="annuaireOuvert.set(false)"
          aria-label="Fermer"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="ticket-detail-modal-body">
        @if (nombreContactsInstallation() === 0) {
          <p class="ticket-detail-contacts-empty">
            Aucun contact renseigné pour cette installation.
          </p>
        } @else {
          @for (groupe of groupesContacts; track groupe.key) {
            @if (contactsInstallation(groupe.key).length) {
              <section class="ticket-detail-contacts-group">
                <h3>{{ groupe.label }}</h3>
                <div class="ticket-detail-contacts-list">
                  @for (contact of contactsInstallation(groupe.key); track contact.id) {
                    <article class="ticket-detail-contact-card">
                      <span class="material-symbols-outlined ticket-detail-contact-avatar"
                        >person</span
                      >
                      <div>
                        <strong>{{ contact.prenom }} {{ contact.nom }}</strong>
                        @if (contact.email) {
                          <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
                        }
                        @if (contact.portable) {
                          <a [href]="'tel:' + contact.portable">{{ contact.portable }}</a>
                        } @else if (contact.telephone) {
                          <a [href]="'tel:' + contact.telephone">{{ contact.telephone }}</a>
                        }
                      </div>
                    </article>
                  }
                </div>
              </section>
            }
          }
        }
      </div>
    </div>
  </div>
}
